import { render, staticRenderFns } from "./SubApprovalsList.vue?vue&type=template&id=c41eac98"
import script from "./SubApprovalsList.vue?vue&type=script&lang=js"
export * from "./SubApprovalsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports